<template>
    <div class="bank__data">
        <img :src="bank" >
        <div class="text">暂无数据</div>
    </div>
</template>

<script>

    import bank from '@/assets/img/404.png'
    export default {
        data (){
            return {
                bank
            }
        },
    }
</script>

<style scoped>
</style>
<style lang="scss">
    .bank__data{
        font-size: 180px;
        text-align: center;
        img{
            width: 400px;
        }
        .text{
            font-size: 25px;
            color: #c3c3c3;
        }
    }
</style>

